export enum Routes {
  INDEX = "/",
  SIGN_IN = "/sign-in",
  REGISTER = "/register",
  RESET_PASSWORD = "/reset-password",
}
